<template>
    <div class="tab-chat-wrapper">
        <Chat/>
    </div>
</template>

<script>
import Chat from '../../UI/chat/Chat';

export default {
    name: 'TabChat',
    components: {
        Chat,
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    .tab-chat-wrapper {
        width: 100%;
        height: auto;
    }

    @import "../../../styles/variables";
    @media (max-width: $vm) {
        .tab-chat-wrapper {
            width: 100%;
            height: 100%;
        }
    }
</style>
